export const FETCH_SYNONYMS = "FETCH_SYNONYMS"
export const RECEIVE_SYNONYMS = "RECEIVE_SYNONYMS"
export const UPDATE_SYNONYMS = "UPDATE_SYNONYMS"

export const updateSynonyms = (params, success, error) => ({
  type: UPDATE_SYNONYMS,
  params,
  success,
  error,
})

export const receiveSynonyms = (params) => ({
  type: RECEIVE_SYNONYMS,
  params,
})

export const fetchSynonyms = (success, error) => ({
  type: FETCH_SYNONYMS,
  success,
  error,
})
